import React from 'react'
import ProductBlockHorizontal from '../../../react4xp/components/ProductBlockHorizontal'

function ProductCardPart({ title, intro, bgColor, position, url, isExternal, image, hoverTilt }) {
    return (
        <ProductBlockHorizontal
            section={{bgColor}}
            productPosition={position}
            href={url?.href}
            external={isExternal}
            src={image?.link}
            alt={image?.alt}
            srcMobile={image?.link}
            hoverTilt={hoverTilt}
            title={title}
            desc={intro}
        />
    )
  }

export default (props) => <ProductCardPart {...props} />
